




































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import AuthService from "@/services/auth.service";
import DataTableComponents from "@/components/App/Assets/Card/Body/CardType/DataTable/SimpleDataTable.vue";
const auth = new AuthService();

@Component({
  components: {
    DataTableComponents,
  },
})
export default class InternalReviewGridComponent extends Vue {
  @Action("create", { namespace: "assessmentForm" }) createReview: any;
  @Action("setReviewId", { namespace: "assessmentForm" }) setReview: any;
  @Prop() items: any;
  @Prop() entity: any;

  reviewAllowedStatus = _app.internalReviewAllowedStatus;
  readonlyStatus = [
    _app.reviewStatus.COI_Rejected,
    _app.reviewStatus.Internal_Submitted,
  ];
  filterByKey = "";
  appSummary: any = {};
  authoptions: any = {};
  // data() {
  //   let payload = this.$store.state["internalReviewIndex"];
  //   payload.orgFields = payload.fields;
  //   payload.data = this.items;
  //   return payload;
  // }

  get appItems() {
    return this.items;
  }

  /*** data table options  */
  get options() {
    return {
      accessRights: this.checkBtnRights
    }
  }

  mounted() {
    let rootState = this.$store.state;
    let payload = this.$store.state.dashboard;
    let componentName = "internalReviewIndex";

    let header = [],
      totalFields,
      fieldsList = [];

    //#.Filter component enabled.
    if (payload.template.filter == true) {
      payload.cards.push("FilterComponent");
      payload.title.push("Filter");
    }

    auth.getUser().then((user: any) => {
      if (user && user.profile) {
        this.authoptions = {
          userInfo: {
            userName: user.profile.given_name,
            updatedUserDd: "",
            updatedUserBa: "",
          },
          modifiedAt: this.formattedDate(),
        };
      }
    });

    // @ts-ignore
    _.forOwn(rootState[componentName].fields, function (key, val) {
      if (
        key.primaryKey != true &&
        key.parent != true &&
        key.list != false &&
        key.type != "Hidden"
      ) {
        if (!key.orgTitle) key.orgTitle = key.title;

        if (payload.keyTranslator) key.text = key.orgTitle;
        else key.text = key.title;

        key.title = key.text;
        // @ts-ignore
        header.push(key);
      }

      if (
        !key.primaryKey &&
        key.type != "Hidden" &&
        !key.create &&
        !key.parent
      ) {
        // @ts-ignore
        fieldsList.push(key.value);
      }
    });

    rootState[componentName].headers = header;

    // this.callProposalCallFilter("");

    // @ts-ignore
    this.$store.dispatch("load", this.$store.state["internalReviewIndex"]);
  }

  downloadPdf(item) {
    this.appSummary = item;
    let temp = {};
    this.$services.reviewinternal
      .reviewSummary(item.ApplicationId, this.entity)
      .then((resp) => {
        if (resp && resp.Result === "ERROR") {
          // not found case
        } else if (resp) {
          temp["sections"]=resp.sections;
          temp["duedeligenceTemp"] = {};
          temp["budgetAsessmentTemp"] = {};
          temp["ddData"] = {};
          temp["budgetData"] = {};
          if (resp["budgetReview"] != null) {
            this.authoptions.userInfo.updatedUserBa = resp["budgetReview"]["UserName"];
            resp["budgetReview"].template.forEach((element) => {
              temp["budgetAsessmentTemp"] = element.Value.properties.budget;
            });
            temp["budgetData"] = resp["budgetReview"]["data"];
          }
          if (resp["ddReview"] != null) {
            this.authoptions.userInfo.updatedUserDd = resp["ddReview"]["UserName"];
            resp["ddReview"].template.forEach((element) => {
              temp["duedeligenceTemp"] =
                element.Value.properties.dueDiligence.properties;
            });
            temp["ddData"] = resp["ddReview"]["data"];
          }
          this.$services.AsessmentPrint.print(
            this.authoptions,
            this.appSummary,
            temp
          );
        }
      });
  }

  formattedDate() {
    const date = new Date();
    return this.$services.format.formatUTC(date);
  }

  /** check the button rights */
  checkBtnRights(field: any, record: any) {
    switch(field.event) {
      case 'edit':
        return this.reviewAllowedStatus.includes(record.StatusCode) && !this.readonlyStatus.includes(record.ReviewStatusId);
        break;
      case 'review':
        return record.ReviewStatusId === this.readonlyStatus[1];
        break;
      case 'download':
        return record.ReviewStatusId === this.readonlyStatus[1];
        break;
      default:
        return true;
    }
  }

  gpouReviewReadOnly(item) {
     let routeData = this.$router.push({
          name: "readOnlyInternalReviewSummary",
          params: { applicationId: item.ApplicationId, entity: this.entity}
    });
  }

  editApplication(item) {
    this.$router.push({
      name: "internalReviewSummary",
      params: { applicationId: item.ApplicationId, entity: this.entity  },
    });

    // const self = this;

    // if (item.InternalReviewId) {
    //   self.setReview(item.InternalReviewId);
    //   self.$router.push({
    //     name: "internalReviewSummary",
    //   });
    // } else {
    //   self
    //     .createReview({ ApplicationId: item.ApplicationId })
    //     .then((data: any) => {
    //       if (data && data.InternalReviewId) {
    //         self.setReview(data.InternalReviewId);
    //         self.$router.push({
    //           name: "internalReviewSummary",
    //         });
    //       }
    //     });
    // }
  }

  downloadApplication(data) {
    const self = this;
  }

  deleteApplication(data) {
    const self = this;
  }
}
